import CustomerCareServicesFactory from '../Services/factory.js'
import DateValueObjectsFactory from '../ValueObjects/factory.js'
import {CheckOpenHoursCustomerCareUseCase} from './CheckOpenHoursCustomerCareUseCase.js'
export default class CustomerCareUseCasesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {CheckOpenHoursCustomerCareUseCase}
   */
  static checkOpenHoursCustomerCareUseCase = ({config}) =>
    new CheckOpenHoursCustomerCareUseCase({
      config,
      checkOpenHoursCustomerCareService: CustomerCareServicesFactory.checkOpenHoursCustomerCareService({config}),
      dateValueObjectFactory: DateValueObjectsFactory.dateValueObject
    })
}
